import React from 'react'
import clsx from 'clsx'
import { classToFComponent, type FCClassContext } from 'cube-react'

import { BrDivider, BrHeader, type BrHeaderLink } from '@govbr-ds/react-components'
import Link from '@/shared/view/components/Link'

import Sel from '@/shared/view/CssSelectors'
import Icons from '@/shared/AppIcons'

import { HeaderScope, QuickLink } from '../main.scope'

const styles = {
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingRight: '1rem'
    },
    logoImage: {
        height: '45px',
        objectFit: 'contain' as const
    },
    appTitle: {
        fontSize: '1.6rem',
        fontWeight: 700,
        color: 'var(--primary-color)',
        textDecoration: 'none',
        letterSpacing: '-0.5px'
    },
    subTitle: { fontSize: '0.9rem', opacity: 0.85, color: '#555' },
    version: { fontSize: '0.8rem', alignSelf: 'center', color: '#999' }
} satisfies Record<string, React.CSSProperties>

export type HeaderProps = {
    className?: string
    fluid?: boolean | 'sm' | 'md' | 'lg' | 'xl'
    scope: HeaderScope
}

class HeaderClass implements FCClassContext<HeaderProps> {
    scope!: HeaderScope

    quickLinkData = [] as BrHeaderLink[]
    quickLinkVersion = -1

    render({ className, fluid, scope }: HeaderProps) {
        this.scope = scope

        if (this.quickLinkVersion !== scope.quickLinkVersion) {
            this.quickLinkData = this.quickAccessLinksAdaptor(scope.quickLinkData)
            this.quickLinkVersion = scope.quickLinkVersion
        }

        // Componente customizado para o topo: Título à esquerda, Logo à direita
        const CustomHeaderContent = (
            <div style={styles.headerContainer}>
                <div>
                    <Link onClick={this.scope.onHome} style={styles.appTitle}>
                        BulaCerta AI
                    </Link>
                    <div className={clsx(Sel.textBase, Sel.textWeightRegular, Sel.dFlex)}>
                        <span style={styles.subTitle}>Plataforma Inteligente para Consulta Segura de Medicamentos</span>
                        <BrDivider vertical ml={2} mr={2} />
                        <span style={styles.version}>v{scope.version}</span>
                    </div>
                </div>
                <div className={Sel.flexGrow1} />
                <img src={Icons.lifeshubLogoUrl} alt="Lifeshub" style={styles.logoImage} />
            </div>
        )

        return (
            <BrHeader
                className={clsx('lifeshub-header', className)}
                fluid={fluid}
                showMenuButton
                showSearchBar={false}
                signature={''}
                menuId="main-navigation"
                title={CustomHeaderContent}
                subTitle={<></>}
                loggedIn={scope.loggedIn}
                onClickLogin={this.scope.onClickLogin}
                onSearch={this.scope.onBuscaTermo}
            />
        )
    }

    quickAccessLinksAdaptor(src: QuickLink[]) {
        const tgt: BrHeaderLink[] = []
        for (const srcItem of src) {
            tgt.push({ label: srcItem.label, onClick: srcItem.onClick })
        }
        return tgt
    }
}

export default classToFComponent<HeaderProps>(HeaderClass)
